import React from 'react';
export function PreBabyJeans() {
  return <section className="py-10 md:py-20 px-4 bg-brand-sage text-white text-center" data-id="element-119">
      <div className="max-w-3xl mx-auto" data-id="element-120">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 font-heading" data-id="element-121">
          Stop weighing yourself. Start zipping up.
        </h2>
        <p className="text-xl md:text-2xl font-light leading-relaxed opacity-90" data-id="element-122">
          The scale is a liar, but these jeans aren't. Our method focuses on
          closing the core and reducing inflammation so you can finally retire
          your maternity pants for good.
        </p>
      </div>
    </section>;
}